import React from "react";
import coolPlatinumImg from "./../../../../Images/Blog/Top 10 hairColor/Cool Platinum Blonde.png";
import HairServImg from "../HairBotox/HairServImg";

const CoolPlatinum = () => {
  return (
    <div className="blogHead-content">
      <HairServImg hairBotoxImg={coolPlatinumImg} />
      <h2>2. Cool Platinum Blonde</h2>
      <p>
        Platinum blonde continues to be a favorite, and in 2024, it's all about
        cool, icy tones. Cool Platinum Blonde is one of the{" "}
        <a href="https://scentlifestyle.com/top-10-trending-women-hair-colours-and-highlights-for-2024">Top 10 Trending Women Hair Colours & Highlights for 2024</a>,
        offering a sleek and modern look. This shade is perfect for those who
        want to make a statement and stand out in the crowd. It requires proper
        maintenance and care, but the result is a stunning, ethereal look that
        exudes confidence and style. Pair it with straight, sleek hairstyles for
        a chic finish.
      </p>
    </div>
  );
};

export default CoolPlatinum;
